import * as React from 'react';
import { Switch, Router, Route } from 'react-router';
import { passApplication } from '@unitedtraders/application-bootstrapper';
import { AuthModal } from '../AuthModal';
import { DepositModal } from '../DepositModal';
import { WithdrawModal } from '../WithdrawModal';
import { ConversionModal } from '../ConversionModal';

const modals = [
  { pathname: 'auth', Component: AuthModal },
  { pathname: 'deposit', Component: DepositModal },
  { pathname: 'withdraw', Component: WithdrawModal },
  { pathname: 'conversion', Component: ConversionModal }
];

export const Modals = passApplication(({ application: { history } }) => {
  return (
    <Router history={history}>
      <Switch>
        {modals.map(({ pathname, Component }, i) => (
          <Route
            key={i}
            path={`*/${pathname}`}
            render={({ match: { url } }) => {
              const [, baseUrl, homeUrl] = url.match(new RegExp(`^((.*)\\/${pathname})`));
              const onClose = () => history.push(homeUrl);
              return <Component baseUrl={baseUrl} onClose={onClose} />;
            }}
          />
        ))}
      </Switch>
    </Router>
  );
});



// WEBPACK FOOTER //
// ./src/components/Modals/index.jsx